function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M120.4 212.3c-11.7 0-21.2-9.5-21.2-21.2s9.5-21.2 21.2-21.2 21.2 9.5 21.2 21.2c0 11.8-9.5 21.2-21.2 21.2zm0-27.8a6.7 6.7 0 106.7 6.7c0-3.7-3-6.7-6.7-6.7zM177.3 174.8c-10.5 0-19-8.5-19-19s8.5-19 19-19 19 8.5 19 19c-.1 10.5-8.6 19-19 19zm0-23.5c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5-2.1-4.5-4.5-4.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.7 21.2l17.6 215c2 22.8 21 40.3 43.9 40.4h81.6c22.9-.1 42-17.7 43.9-40.5l17-214.9h-204zm173.2 28.5L209 99.2H74.7l-4-49.5h142.2zm-30.1 198.4h-81.6c-8.1 0-14.8-6.2-15.5-14.2L77 127.7h129.7l-8.4 106.2c-.7 8-7.4 14.2-15.5 14.2z"
})));